/**
 * Checkout FE `event_type` values accepted by events-gateway.
 *
 * Mirrored from `@appcharge/frontend-events` leaf DTO `EVENT_TYPE`s (v1.3+) —
 * kept as local string constants so the hot path does not eagerly pull the
 * DTO package into the initial bundle. Unit tests assert these do not drift
 * from the package.
 */
export const FrontendCheckoutEventType = {
  CHECKOUT_LIFECYCLE: 'CHECKOUT_LIFECYCLE',
  ORDER_AWARDING: 'ORDER_AWARDING',
  PAYMENT_INTENT: 'PAYMENT_INTENT',
} as const;

export type FrontendCheckoutEventType =
  (typeof FrontendCheckoutEventType)[keyof typeof FrontendCheckoutEventType];
